import { atom } from 'recoil';

import { localStorageEffect } from 'hooks/verify-organization/state';

export const drafts = atom<Record<string, Record<string, string>>>({
  key: 'admin.auctions.drafts',
  effects: [localStorageEffect('admin.auctions.drafts')],
  default: {},
});
